import axios from 'axios';

export const saveSetupVolume = (NumberOfShipments) => {
  return axios.post('/seller/onboarding/setup', { NumberOfShipments });
};

export const updateCompanyNameAndPhone = (companyName = '', phoneNumber = '') => {
  return axios.post('/seller/updateCompanyNameAndPhone', { companyName, phoneNumber });
};

/**
 * Updates billing info address for the seller
 * @param {import('src/financial-services-ui/mapping').BillingInfoData} billingInfo
 * @returns {Promise<void>} Resolves when billing info added to seller record
 */
export const updateSellerBillingInfo = async (billingInfo) => {
  return axios.post('/seller/updateBillingAddress', billingInfo);
};
